import { v4 as uuidv4 } from "uuid";
import { useState } from 'react';
import axios from 'axios';
import { BASEURL } from "../../../../../constants";
import { RightChevron, CrossSVG } from "../../../../Icons/icons";

const FileUploadModal = ({ setIsDataSaved, setFileModal, setCurrentSlideData, insertAt }) => {

    const [isHovered, setIsHovered] = useState(false);
    const [file, setFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    console.log("file data" , file)

    const handleFileDrop = (event) => {
        event.preventDefault();
        const droppedFile = event.dataTransfer.files[0];

        if (droppedFile) {
            setFile(droppedFile);
        }
        setIsHovered(false);
    };

    const handleBrowseFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    };

    const handleUpload = async () => {
        setIsUploading(true);

        const uniqueId = uuidv4();
        const formData = new FormData();
        formData.append('file', file);
        formData.append('key', uniqueId);

        try {
            const response = await axios.post(`${BASEURL}/api/upload-file`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            setIsUploading(false);
            setIsDataSaved(false);
            setFileModal(false);

            const creatingContentObject = {
                id: uniqueId,
                data: { fileName: file.name, fileKey: uniqueId , fileType: file.type },
                type: 'File' 
            };

            setCurrentSlideData((currentSlideData) => {
                if (insertAt === currentSlideData.content.length) {
                    return {
                        ...currentSlideData,
                        content: [...currentSlideData.content, creatingContentObject],
                        fileIdArray: [...currentSlideData.fileIdArray, uniqueId]
                    };
                } else {
                    return {
                        ...currentSlideData,
                        content: [
                            ...currentSlideData.content.slice(0, insertAt),
                            creatingContentObject,
                            ...currentSlideData.content.slice(insertAt)
                        ],
                        fileIdArray: [...currentSlideData.fileIdArray, uniqueId]
                    };
                }
            });

        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };

    const clearFile = () => {
        setFile(null);
    };

    return (
        <div className="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">

            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

            <div className="fixed h-full inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">

                    <div style={{ minWidth: '40%' }} className="relative p-3 h-auto transform flex-col justify-evenly bg-white text-left shadow-xl transition-all my-8">
                        <div className="text-right">
                            <span className="inline-block cursor-pointer" onClick={() => {
                                setFileModal(false);
                            }}>
                                <CrossSVG />
                            </span>
                        </div>
                        <div
                            className={`border-2 border-dashed p-4 cursor-pointer ${isHovered ? 'border-blue-500 bg-blue-100' : 'border-gray-300'}`}
                            onDragOver={(e) => {
                                e.preventDefault();
                                setIsHovered(true);
                            }}
                            onDragLeave={() => setIsHovered(false)}
                            onDrop={handleFileDrop}
                        >
                            {
                                file ? (
                                    <div>{file.name}</div>
                                ) : (
                                    <>
                                        <div className="text-center">
                                            <div className="w-20 h-12 mx-auto mb-2 bg-[#EDECF9] rounded-xl flex items-center justify-center">
                                              
                                            </div>
                                            <p className="text-gray-600">Upload or drag & drop file here</p>
                                            <button
                                                onClick={() => document.getElementById('fileInput').click()}
                                                className="text-blue-500 font-semibold"
                                            >
                                                Browse
                                            </button>
                                        </div>
                                        <input
                                            id="fileInput"
                                            type="file"
                                            accept="*"
                                            className="hidden"
                                            onChange={handleBrowseFileChange}
                                        />
                                    </>
                                )
                            }
                        </div>
                        <p className="text-sm text-gray-500 mt-2">The maximum size per file is 10 MB</p>
                        <div className="flex justify-end mt-4 space-x-2">
                            <button disabled={isUploading} onClick={clearFile} className="px-2 py-1 bg-gray-200 text-gray-700">Clear</button>
                            <button onClick={handleUpload} className="px-2 py-1 bg-customPrimaryPurple text-white">{isUploading ? 'Uploading...' : 'Upload'}</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default FileUploadModal;